export default [
  { value: "Unknown", text: "Unknown" },
  { value: "Premier", text: "Premier" },
  { value: "MPerks", text: "Member Perks" },
  { value: "ERewards", text: "Elite Rewards" },
  { value: "EPC", text: "EPC" }
];
